import { render, staticRenderFns } from "./DealsPage.vue?vue&type=template&id=57c75c3a&scoped=true"
import script from "./DealsPage.vue?vue&type=script&lang=js"
export * from "./DealsPage.vue?vue&type=script&lang=js"
import style0 from "./DealsPage.vue?vue&type=style&index=0&id=57c75c3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c75c3a",
  null
  
)

export default component.exports